import { MaterialService } from './material.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { Business, BusinessList } from '../model/business.model';
import { BusinessDocument, BusinessDocumentList } from '../model/businessDocument.model';

@Injectable({
    providedIn: 'root'
})
export class BusinessService extends KiwixiService {
    apiBusinessUrl = environment.server + 'business/';


    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    get(params: any): Observable<BusinessList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._httpClient.get<BusinessList>(this.apiBusinessUrl, {
            params: params,
            headers: header
        });
    }

    getOne(id: any, salt = false): Observable<Business> {
        const header = this.createHttpClientAuthorizationHeader();
        let url = this.apiBusinessUrl + id + '/';
        if (salt)
            url += '?salt=' + Math.random();
        return this._httpClient.get<Business>(url, {
            headers: header
        });
    }

    post(data): Observable<Business> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._httpClient.post<Business>(this.apiBusinessUrl, data, { headers: header });
    }

    patch(data, id): Observable<Business> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._httpClient.patch<Business>(this.apiBusinessUrl + id + '/', data, { headers: header });
    }

    getElasticSearch(params: any): Observable<BusinessDocumentList> {
        const header = this.createOptionalAuthHeader();
        return this._httpClient.get<BusinessDocumentList>(environment.server + 'elastic_search/business/', {
            params: params,
            headers: header
        });
    }

    getElasticSearchSuggest(params: any): Observable<any> {
        const header = this.createOptionalAuthHeader();
        return this._httpClient.get<any>(environment.server + 'elastic_search/business_suggest/', {
            params: params,
            headers: header
        });
    }

    getElasticSearchExactAutreBusiness(params?: any): Observable<BusinessDocument> {
        const header = this.createOptionalAuthHeader();
        return this._httpClient.get<BusinessDocument>(environment.server + 'elastic_search/exact_autre_business/', {
            params: params,
            headers: header
        });
    }
}
